module.exports = __webpack_public_path__ + "img/pay2.efa41ddc.png";